<template>
	<v-dialog :value="value" max-width="820" persistent @input="emitInput">
		<v-card class="carnet-card">
			<div class="carnet-topbar">
				<div class="carnet-topbar__brand">
					<img class="carnet-topbar__logo" src="/logoBol1.png" alt="Logo institucional" />
				</div>
				<div class="carnet-topbar__heading">
					<div class="carnet-topbar__title">Policia Boliviana</div>
					<div class="carnet-topbar__eyebrow">Carnet digital institucional</div>
				</div>
				<v-btn icon class="carnet-close" @click="cerrar">
					<v-icon color="#384018">mdi-close</v-icon>
				</v-btn>
			</div>

			<v-card-text class="carnet-body">
				<div class="carnet-photo-panel">
					<div class="carnet-panel-accent"></div>
					<div class="carnet-photo-frame">
						<v-icon size="148" color="#c9a538">mdi-account-circle</v-icon>
					</div>
					<div class="carnet-document">						
						<span class="carnet-document__value">{{ perfil.documento || '18000000' }}</span>
					</div>
					<div class="carnet-status" :class="perfil.activo ? 'carnet-status--active' : 'carnet-status--inactive'">
						{{ perfil.activo ? 'Activo' : 'Inactivo' }}
					</div>
				</div>

				<div class="carnet-info-panel" :style="infoPanelStyle">
					<div class="carnet-info-panel__header">						
						<div class="carnet-info-panel__grade">Grado: {{ displayGrado }}</div>
					</div>
					<div class="carnet-info-panel__content">
						<div class="carnet-info-panel__summary">
							<div class="carnet-details">
								<p class="carnet-line"><span class="carnet-line__label">Nombre(s)</span><span class="carnet-line__value">{{ perfil.nombres || '-' }}</span></p>
								<p class="carnet-line"><span class="carnet-line__label">Apellido Paterno</span><span class="carnet-line__value">{{ perfil.primero_apellido || '-' }}</span></p>
								<p class="carnet-line"><span class="carnet-line__label">Apellido Materno</span><span class="carnet-line__value">{{ perfil.segundo_apellido || '-' }}</span></p>
								<p class="carnet-line"><span class="carnet-line__label">No. Documento</span><span class="carnet-line__value">{{ perfil.documento || '18000000' }}</span></p>
								<p class="carnet-line"><span class="carnet-line__label">Nivel</span><span class="carnet-line__value">{{ perfil.document || 'Oficial' }}</span></p>
							</div>
							<div class="carnet-qr-panel">
								<div class="carnet-qr-frame">
									<qrcode-vue
										:value="qrValue"
										:size="110"
										level="M"
									/>
								</div>							
								<div class="carnet-qr-caption">Validacion QR</div>
							</div>
						</div>
						<div class="carnet-details carnet-details--wide">
							<p class="carnet-line"><span class="carnet-line__label">Unidad</span><span class="carnet-line__value">{{ perfil.unidad || 'COMANDO DEPARTAMENTAL LA PAZ' }}</span></p>
							<p class="carnet-line"><span class="carnet-line__label">Destino</span><span class="carnet-line__value">{{ perfil.destino || 'UNIDAD DE RADIO PATRULLAS 110 - LA PAZ' }}</span></p>
						</div>
					</div>
				</div>
			</v-card-text>

			<v-card-actions class="carnet-actions">
				<v-btn class="carnet-button" @click="cerrar">
					<v-icon left>mdi-close</v-icon>
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
	name: 'Carnet',
	components: {
		QrcodeVue
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		perfil: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		displayGrado() {
			return this.perfil.grado_nombre || this.perfil.grado?.nombre || 'General Mayor';
		},
		infoPanelStyle() {
			return {
				'--carnet-watermark': `url('${process.env.BASE_URL}logoBol1.png')`
			};
		},
		fullName() {
			return [this.perfil.nombres, this.perfil.primero_apellido, this.perfil.segundo_apellido]
				.filter(Boolean)
				.join(' ') || 'Funcionario policial';
		},
		qrValue() {
			const codigo = this.perfil.codigo_carnet || this.perfil.id || '';

			return `${window.location.origin}/validar-carnet/${codigo}`;
		}
	},
	methods: {
		emitInput(value) {
			this.$emit('input', value);
		},
		cerrar() {
			this.$emit('input', false);
		}
	}
};
</script>

<style scoped>
.carnet-card {
	overflow: hidden;
	border-radius: 24px !important;
	background:
		radial-gradient(circle at top right, rgba(247, 195, 37, 0.34), transparent 30%),
		radial-gradient(circle at bottom left, rgba(94, 103, 44, 0.12), transparent 24%),
		linear-gradient(135deg, #f7f8f3 0%, #eef0ea 100%) !important;
	box-shadow: 0 22px 46px rgba(51, 58, 25, 0.18);
}

.carnet-topbar {
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 12px;
	padding: 22px 24px 4px;
}

.carnet-topbar__brand {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	min-width: 68px;
}

.carnet-topbar__logo {
	width: 58px;
	height: 58px;
	object-fit: contain;
}

.carnet-topbar__heading {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	text-align: left;
}

.carnet-topbar__eyebrow {
	color: #727b4a;
	font-size: 13px;
	font-weight: 800;
	text-transform: uppercase;
	letter-spacing: 0.18em;
	margin-top: 6px;
}

.carnet-topbar__title {
	color: #384018;
	font-size: 30px;
	font-weight: 800;
	line-height: 1;
	text-transform: uppercase;
	letter-spacing: 0.02em;
}

.carnet-close {
	background: rgba(255, 255, 255, 0.85);
	border: 1px solid rgba(108, 117, 51, 0.14);
}

.carnet-body {
	display: grid;
	grid-template-columns: 188px minmax(0, 1fr);
	gap: 18px;
	padding: 8px 24px 10px !important;
	align-items: stretch;
}

.carnet-photo-panel {
	background: linear-gradient(180deg, #5e672c 0%, #41481f 100%);
	border-radius: 22px;
	padding: 16px 14px 16px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: center;
	gap: 8px;
	position: relative;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.carnet-panel-accent {
	width: 56px;
	height: 4px;
	border-radius: 999px;
	background: linear-gradient(90deg, rgba(255, 255, 255, 0.2), rgba(226, 187, 65, 0.9));
	margin-bottom: 2px;
	align-self: center;
}

.carnet-photo-frame {
	width: 100%;
	height: 148px;
	border-radius: 24px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
	border: 1px solid rgba(255, 255, 255, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.carnet-document {
	width: 100%;
	padding: 6px 8px;
	border-radius: 14px;
	background: rgba(255, 255, 255, 0.08);
	border: 1px solid rgba(255, 255, 255, 0.12);
	text-align: center;
	color: #ffffff;
	font-size: 12px;
	line-height: 1.1;
	word-break: break-word;
}

.carnet-document__label {
	display: block;
	font-weight: 800;
	text-transform: uppercase;
	letter-spacing: 0.14em;
	margin-bottom: 2px;
	color: rgba(255, 255, 255, 0.74);
}

.carnet-document__value {
	font-weight: 700;
	font-size: 1.28rem;
	color: white;
	letter-spacing: 0.03em;
}

.carnet-status {
	width: 100%;
	padding: 7px 14px;
	border-radius: 999px;
	color: #ffffff;
	font-size: 12px;
	font-weight: 800;
	text-align: center;
	text-transform: uppercase;
	letter-spacing: 0.14em;
}

.carnet-status--active {
	background: rgba(76, 175, 80, 0.32);
	border: 1px solid rgba(129, 199, 132, 0.52);
}

.carnet-status--inactive {
	background: rgba(211, 47, 47, 0.28);
	border: 1px solid rgba(239, 154, 154, 0.45);
}

.carnet-info-panel {
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(248, 249, 245, 0.86));
	border: 1px solid rgba(108, 117, 51, 0.1);
	border-radius: 22px;
	padding: 8px 18px 16px;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
	position: relative;
	overflow: hidden;
}

.carnet-info-panel::before {
	content: '';
	position: absolute;
	inset: 0;
	background-image:
		radial-gradient(circle at 42% 50%, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.72) 68%),
		var(--carnet-watermark);
	background-position: center, 42% calc(50% + 25px);
	background-repeat: no-repeat, no-repeat;
	background-size: cover, 42%;
	opacity: 0.18;
	pointer-events: none;
	filter: grayscale(1) brightness(1.45) contrast(0.9);
}

.carnet-info-panel > * {
	position: relative;
	z-index: 1;
}

.carnet-info-panel__header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
	padding-bottom: 5px;
	margin-bottom: 5px;
	border-bottom: 1px solid rgba(108, 117, 51, 0.14);
}

.carnet-info-panel__kicker {
	font-size: 11px;
	font-weight: 800;
	letter-spacing: 0.18em;
	text-transform: uppercase;
	color: #7b8450;
	margin-bottom: 6px;
}

.carnet-info-panel__name {
	font-size: 21px;
	font-weight: 800;
	line-height: 1.1;
	color: #384018;
}

.carnet-info-panel__grade {
	flex-shrink: 0;
	padding: 8px 12px;
	border-radius: 999px;
	background: rgba(94, 103, 44, 0.1);
	color: #5e672c;
	font-size: 12px;
	font-weight: 800;
	letter-spacing: 0.06em;
	text-transform: uppercase;
}

.carnet-info-panel__content {
	display: flex;
	flex-direction: column;
	gap: 10px;
	min-width: 0;
	height: 100%;
	}

.carnet-info-panel__summary {
	display: grid;
	grid-template-columns: minmax(0, 1fr) 126px;
	gap: 16px;
	align-items: start;
}

.carnet-details {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	min-width: 0;
	gap: 4px;
}

.carnet-details--wide {
	gap: 0;
}

.carnet-line {
	margin: 0;
	display: grid;
	grid-template-columns: 136px minmax(0, 1fr);
	gap: 10px;
	align-items: start;
	color: #303641;
	font-size: 14px;
	line-height: 1.2;
	word-break: break-word;
	padding: 5px 0;
}

.carnet-line + .carnet-line {
	margin-top: 0;
	border-top: 1px solid rgba(108, 117, 51, 0.08);
}

.carnet-line__label {
	color: #727b4a;
	font-weight: 800;
	text-transform: uppercase;
	font-size: 10px;
	letter-spacing: 0.08em;
	padding-top: 3px;
	white-space: nowrap;
}

.carnet-line__value {
	color: #384018;
	font-weight: 700;
}

.carnet-details--wide .carnet-line {
	grid-template-columns: 86px minmax(0, 1fr);
}

.carnet-qr-panel {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
}

.carnet-qr-frame {
	width: 126px;
	height: 126px;
	padding: 8px;
	border-radius: 18px;
	background: linear-gradient(180deg, #f8f9f5 0%, #eef0ea 100%);
	border: 1px solid rgba(108, 117, 51, 0.14);
	box-shadow: 0 10px 24px rgba(86, 96, 42, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.carnet-qr-image {
	display: block;
	width: 100%;
	height: 100%;
	border-radius: 12px;
}

.carnet-qr-caption {
	color: #727b4a;
	font-size: 11px;
	font-weight: 800;
	text-transform: uppercase;
	letter-spacing: 0.16em;
	text-align: center;
}

.carnet-actions {
	justify-content: center;
	padding: 4px 24px 24px;
}

.carnet-button {
	background: #5e672c !important;
	color: #ffffff !important;
	border-radius: 12px !important;
	padding: 0 18px !important;
	box-shadow: 0 10px 24px rgba(73, 81, 34, 0.24);
}

@media (max-width: 760px) {
	.carnet-topbar {
		grid-template-columns: auto 1fr auto;
		gap: 12px;
	}

	.carnet-topbar__brand {
		min-width: 52px;
	}

	.carnet-topbar__logo {
		width: 42px;
		height: 42px;
	}

	.carnet-body {
		grid-template-columns: 1fr;
	}

	.carnet-info-panel__header {
		flex-direction: column;
		align-items: flex-start;
	}

	.carnet-info-panel__content {
		gap: 12px;
	}

	.carnet-info-panel__summary {
		grid-template-columns: 1fr;
	}

	.carnet-line {
		grid-template-columns: 1fr;
		gap: 4px;
	}

	.carnet-details--wide .carnet-line {
		grid-template-columns: 1fr;
	}

	.carnet-qr-panel {
		padding-top: 8px;
	}

	.carnet-topbar__title {
		font-size: 24px;
	}

	.carnet-topbar__eyebrow {
		font-size: 13px;
		letter-spacing: 0.12em;
	}
}
</style>
